<template>
    <div class="pa-pagination">
        <span>{{ rangeText }}</span>
        <div class="pa-pagination__right">
            <div class="pa-pagination__size">
                <span>Por página</span>
                <v-select :value="itemsPerPage" :items="itemsPerPageOptions" dense outlined hide-details :menu-props="{ offsetY: true }"
                    @change="changeSize"></v-select>
            </div>
            <div class="pa-pagination__pager">
                <v-btn outlined small :disabled="page <= 1" aria-label="Página anterior" @click="$emit('update:page', page - 1)">
                    <v-icon small>mdi-chevron-left</v-icon>
                </v-btn>
                <span>{{ page }} / {{ pageCount }}</span>
                <v-btn outlined small :disabled="page >= pageCount" aria-label="Próxima página" @click="$emit('update:page', page + 1)">
                    <v-icon small>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
// Rodape de tabela: "1–10 de N", itens por pagina e "‹ pagina / total ›".
// Use com .sync em page e items-per-page.
export default {
    name: "PaPagination",
    props: {
        total: { type: Number, default: 0 },
        page: { type: Number, default: 1 },
        itemsPerPage: { type: Number, default: 10 },
        itemsPerPageOptions: { type: Array, default: () => [10, 25, 50, 100] },
    },
    computed: {
        pageCount() {
            return Math.max(1, Math.ceil(this.total / this.itemsPerPage));
        },
        rangeText() {
            if (!this.total) return "Nenhum registro";
            const start = (this.page - 1) * this.itemsPerPage + 1;
            const end = Math.min(this.total, this.page * this.itemsPerPage);
            return `${start.toLocaleString("pt-BR")}–${end.toLocaleString("pt-BR")} de ${this.total.toLocaleString("pt-BR")}`;
        },
    },
    methods: {
        changeSize(size) {
            this.$emit("update:itemsPerPage", size);
            this.$emit("update:page", 1);
        },
    },
};
</script>
